import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {UserRoleCategoryModel} from '../../../../shared/dto/user-role-category.model';
import {UserroleCategoryService} from '../../../../shared/service/userrole-category.service';
import swal from "sweetalert2";
import {UserRoleModel} from '../../../../shared/dto/user-role.model';
import {UserRoleService} from '../../../../shared/service/userrole.service';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-user-role-popup',
  templateUrl: './user-role-popup.component.html',
  styleUrls: ['./user-role-popup.component.scss']
})
export class UserRolePopupComponent implements OnInit {
  @Input() userRoleMgtCopy_: UserRoleModel[];
  userRoleMgt: any;
  public userRolePopup: FormGroup;
  public userRoleCategories: UserRoleCategoryModel [] = [];
  public userRoleCode: string;
  public description: string;
  public userRoleCategoryName: string;
  public selectedState: string;
  public selectedMode;

  ActionMode = ActionMode;
  public href: string = "";

  constructor( public activeModal: NgbActiveModal,
               private userroleCategoryService: UserroleCategoryService,
               private userRoleService: UserRoleService,
               private spinnerService: NgxUiLoaderService,
               private tokenStorageService: TokenStorageService,
               private router : Router) { }

  ngOnInit() {
    this.userRolePopup = new FormGroup({
      userRoleCode: new FormControl(null,Validators.required),
      description: new FormControl(null,Validators.required),
      userRoleCategory: new FormControl(null,Validators.required),
      states: new FormControl(null,Validators.required)
    });

    this.userRoleMgt = {...this.userRoleMgtCopy_};
    if (this.selectedMode === ActionMode.VIEW) {
      this.userRolePopup.disable();
    }
    this.href = this.router.url;
    this.loadUserRoleCategories();

  }

  loadUserRoleCategories() {
    this.userroleCategoryService.getAllUserRoleCategory().subscribe(
      (data: UserRoleCategoryModel[]) => {
        this.userRoleCategories = data;
      }
    )
  }

  onSubmit() {
    console.log(this.tokenStorageService.getUserObjectToken());
    let isValid: boolean = true;
    let errorMessage: string = '';

    if (!this.userRolePopup.valid) {
      isValid = false;
      errorMessage = 'Please, Fill the form Data...!'
    }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          const userRoleModel: UserRoleModel = new UserRoleModel(
            this.userRoleCode,
            this.description,
            this.selectedState,
            this.userRoleCategoryName,
            null,
            this.tokenStorageService.getUserObjectToken().username,
            this.href
          );
          this.userRoleService.saveUserRole(userRoleModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.activeModal.close("Saved");
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }


}
